const text = 'text';
const textarea = 'textarea';
const number = 'number';
const button = 'button';
const checkbox = 'checkbox';
const divider = 'divider';

export default {
  text,
  textarea,
  number,
  button,
  checkbox,
  divider
};
